import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
import { BarcodeBookState } from "../../../../../Constants";
import "./CompleteModal.scss";

export function CompleteModal({ books, updateBooks, completeBooks, ...props }) {
  const [t] = useTranslation();

  useEffect(() => {
    updateBooks();
  }, []);

  const canComplete = () => {
    const initialStatusBooks = books.filter(
      (x) => x.state === BarcodeBookState.Initial
    );
    if (initialStatusBooks.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <Modal {...props} centered dialogClassName="complete-modal">
      <Modal.Header className="complete-modal-header" closeButton>
        <div className="title">{t("Complete")}</div>
      </Modal.Header>
      <Modal.Body className="complete-modal-content">
        <div className="saved-message">
          <span className="icon">check</span>
          {t("BooksSaved")}
        </div>
        {canComplete() ? (
          <div className="sub-title">{t("AreYouSureComplete")}</div>
        ) : (
          <div className="sub-title">{t("ToCompleteWarning")}</div>
        )}
        <div className="button-wrapper">
          <Button className="button-cancel" onClick={() => props.onHide()}>
            {t("Close")}
          </Button>
          <Button
            className="button"
            disabled={!canComplete()}
            onClick={completeBooks}
          >
            {t("Complete")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
